import { Button } from 'antd'
import { Check, X, MousePointerClick } from 'lucide-react'
import {
  CATEGORY_STYLES,
  CATEGORY_DISPLAY_NAMES,
  CATEGORY_DISPLAY_NAMES_PLURAL,
} from '../../../constants/mindmapConfig'
import {
  StyledButtonWrapper,
  ButtonText,
} from '../../../components/Mindmap/Panels/styles/MindMapHeaderStyles'
import {
  BannerBar,
  InstructionGroup,
  IconCircle,
  TextGroup,
  InstructionTitle,
  InstructionSubtext,
  CategoryPillsRow,
  CategoryPill,
  ActionsGroup,
} from './BranchSelectionBanner.styles'

interface BranchSelectionBannerProps {
  categoryCounts: Map<string, number>
  title: string
  subtitle: string
  onConfirm: () => void
  onCancel: () => void
}

function getCategoryColor(category: string): string {
  const style = CATEGORY_STYLES[category as keyof typeof CATEGORY_STYLES]
  return style?.iconColor ?? '#9ca3af'
}

function getCategoryLabel(category: string, count: number): string {
  if (count === 1) return CATEGORY_DISPLAY_NAMES[category] ?? category
  return CATEGORY_DISPLAY_NAMES_PLURAL[category] ?? category
}

export function BranchSelectionBanner({
  categoryCounts,
  title,
  subtitle,
  onConfirm,
  onCancel,
}: BranchSelectionBannerProps) {
  const hasSelection = categoryCounts.size > 0
  const totalCount = Array.from(categoryCounts.values()).reduce((sum, c) => sum + c, 0)

  return (
    <BannerBar>
      <InstructionGroup>
        <IconCircle>
          <MousePointerClick size={18} />
        </IconCircle>
        <TextGroup>
          <InstructionTitle>
            {hasSelection ? `${totalCount} node${totalCount !== 1 ? 's' : ''} selected` : title}
          </InstructionTitle>
          {hasSelection ? (
            <CategoryPillsRow>
              {Array.from(categoryCounts.entries()).map(([category, count]) => (
                <CategoryPill key={category} $color={getCategoryColor(category)}>
                  {count} {getCategoryLabel(category, count)}
                </CategoryPill>
              ))}
            </CategoryPillsRow>
          ) : (
            <InstructionSubtext>{subtitle}</InstructionSubtext>
          )}
        </TextGroup>
      </InstructionGroup>

      <ActionsGroup>
        <StyledButtonWrapper>
          <Button type="default" icon={<X size={16} />} onClick={onCancel}>
            <ButtonText>Cancel</ButtonText>
          </Button>
        </StyledButtonWrapper>
        <StyledButtonWrapper>
          <Button
            type="primary"
            icon={<Check size={16} />}
            onClick={onConfirm}
            disabled={!hasSelection}
          >
            <ButtonText>Continue</ButtonText>
          </Button>
        </StyledButtonWrapper>
      </ActionsGroup>
    </BannerBar>
  )
}
